import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { formatINR } from "@/lib/api";
import { toast } from "sonner";

export const ProductCard = ({ product, index = 0 }) => {
  const { addItem } = useCart();
  const onAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addItem({ id: product.id, name: product.name, price: product.price, image: product.image, type: "product" });
    toast.success(`${product.name} added 💝`);
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.45, delay: (index % 4) * 0.05 }}
    >
      <Link
        to={`/product/${product.id}`}
        data-testid={`product-card-${product.id}`}
        className="group block overflow-hidden rounded-wp-lg bg-card border border-border shadow-wp-card transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-wp-lift"
      >
        <div className="relative aspect-square overflow-hidden bg-wp-cream-100">
          <img src={product.image} alt={product.name} loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.06]" />
          <button onClick={onAdd} aria-label={`Add ${product.name}`}
            data-testid={`product-quick-add-${product.id}`}
            className="absolute bottom-2.5 right-2.5 grid h-10 w-10 place-items-center rounded-full bg-white/90 text-wp-rose-strong shadow-wp-soft backdrop-blur transition-[transform,background-color] duration-200 hover:scale-105 hover:bg-white active:scale-95">
            <Plus className="h-4.5 w-4.5" />
          </button>
        </div>
        <div className="p-3">
          <p className="wp-label text-[10px] text-wp-rose-strong">{product.category}</p>
          <h3 className="mt-0.5 line-clamp-1 text-sm font-semibold">{product.name}</h3>
          <span className="price-num mt-1 block text-sm font-semibold text-wp-rose-strong">{formatINR(product.price)}</span>
        </div>
      </Link>
    </motion.div>
  );
};
